'use client';

import { styled } from '@linaria/react';
import useTypewriter from '@fe-news/hooks/use-type-writer';
import { SCREEN_SIZE } from '@fe-news/styles/style';

const H1 = styled.p`
  color: #000000;
  font-size: 19px;
  font-weight: 500;
  line-height: 1.53;
  letter-spacing: 0.5px;
  margin-top: 16px;
  text-align: left;

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    font-size: 18px;
    line-height: 1.44;
    letter-spacing: 0.1px;
  }

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Cursor = styled.span`
  display: inline-block;
  width: 4px;
  height: 12px;
  background-color: #848d97;
  margin-left: 2px;
  animation: blink 0.5s step-end infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

const ArticleTitle = ({
  setIsTitleLoaded,
  title
}: {
  setIsTitleLoaded: (isTitleLoaded: boolean) => void;
  title: string;
}) => {
  const { displayText, isCursor } = useTypewriter({ content: title, onComplete: () => setIsTitleLoaded(true) });

  return (
    <H1>
      {displayText}
      {isCursor && <Cursor />}
    </H1>
  );
};

export default ArticleTitle;
